/*!

=========================================================
* Light Bootstrap Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useMemo} from "react";
// react components used to create a google map
import {
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";


function Maps(props) {


  const CustomMap =
    withGoogleMap(prop => (
      <GoogleMap
        defaultZoom={16}
        defaultCenter={{ lat: props.latitude, lng: props.longitude }}
        defaultOptions={{
          scrollwheel: false,
          zoomControl: true
        }}
      >
        <Marker position={{ lat: props.latitude, lng: props.longitude }} />
        {props.clientLocation.geolocation && <Marker position={{ lat: props.clientLocation.geolocation.latitude, lng: props.clientLocation.geolocation.longitude }} label="!" />}
      </GoogleMap>
    ))


  return useMemo(() => (
    <CustomMap
      googleMapURL={`https://maps.googleapis.com/maps/api/js?${props.apiKey}`}
      loadingElement={<div style={{ height: `100%` }} />}
      containerElement={<div style={{ height: `calc(100vh - 230px)` }} />}
      mapElement={<div style={{ height: `100%` }} />}
    />
  ), [props.clientLocation.geolocation]);
}

export default Maps;
